import { stripLocalePrefix } from '../../i18n/locales';

export type NavItem = Readonly<{
  icon: string;
  labelKey: string;
  route: string;
}>;

export const PRIMARY_NAV_ITEMS = [
  { route: '/dashboard', labelKey: 'navigation.dashboard', icon: 'dashboard' },
  { route: '/demands', labelKey: 'navigation.demands', icon: 'deployed_code' },
  { route: '/control-center', labelKey: 'navigation.controlCenter', icon: 'notifications' },
  { route: '/storage-locations', labelKey: 'navigation.storageLocations', icon: 'warehouse' },
  { route: '/item-catalog', labelKey: 'navigation.itemCatalog', icon: 'list_alt' },
] as const satisfies readonly NavItem[];

export const FOOTER_NAV_ITEMS = [
  { route: '/help', labelKey: 'navigation.help', icon: 'help' },
  { route: '/settings', labelKey: 'navigation.settings', icon: 'settings' },
] as const satisfies readonly NavItem[];

// Shared by both MainNav (route -> is-this-item-active) and ModuleHeader
// (current-route -> label, for the module title). One list, one source of
// truth for "what a nav item is" so the two stay in sync automatically.
export const ALL_NAV_ITEMS: readonly NavItem[] = [...PRIMARY_NAV_ITEMS, ...FOOTER_NAV_ITEMS];

export function findNavItem(url: string): NavItem | undefined {
  const route = stripLocalePrefix(url.split(/[?#]/u, 1)[0]);

  return ALL_NAV_ITEMS.find((item) => item.route === route || route.startsWith(`${item.route}/`));
}

// standalone.routes.ts locale-prefixes every path (e.g. "/en/dashboard") for
// both the dev server and the build-standalone production build;
// app.routes.ts (the federation entry) never does. Stripping it up-front
// lets a consumer match
// the current URL against ALL_NAV_ITEMS' bare routes (e.g. '/dashboard')
// regardless of which bootstrap is active.
export { stripLocalePrefix } from '../../i18n/locales';
